import React, { useEffect, useState } from 'react';
import { BubbleChat } from 'flowise-embed-react';

// Define the bot configuration interface
interface BotConfig {
  chatflowid: string;
  apiHost: string;
  // Removed headers from BotConfig as the worker doesn't seem to return them
  // headers?: Record<string, string>;
}

// Secret key for accessing the worker - in a real app, this should be stored securely
const WORKER_SECRET_KEY = "supercleUltraSecrete123"; // Consider moving to environment variables
const WORKER_URL = "https://bot-production.smitthwillson1213.workers.dev"; // Ensure HTTPS



// Nouveau proxy pour les requêtes API
const API_PROXY_URL = "https://bot-production.smitthwillson1213.workers.dev/api";

const ChatBot: React.FC = () => {
  const [botConfig, setBotConfig] = useState<BotConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Removed isLocalhost state: const [isLocalhost, setIsLocalhost] = useState(false);

  useEffect(() => {
    // Removed localhost check logic

    const loadConfig = async () => {
      setLoading(true); // Set loading true at the start of fetch attempt
      setError(null); // Clear previous errors
      try {
        // Always fetch config from Cloudflare Worker with security key
        console.log("Fetching bot config..."); // Added log
        const response = await fetch(`${WORKER_URL}?key=${WORKER_SECRET_KEY}`, {
          method: 'GET',
          mode: 'cors', // Explicitly set CORS mode
        });

        if (!response.ok) {
          const errorText = await response.text();
          // Log the specific error from the worker response
          console.error(`Worker response error: ${response.status} - ${errorText}`);
          throw new Error(`Failed to load bot configuration: ${response.status}`);
        }

        const data: BotConfig = await response.json();
        console.log("Bot config loaded successfully"); // Added log
            // Remplacer l'apiHost HTTP par notre proxy HTTPS
        const modifiedConfig = {
          ...data,
          apiHost: API_PROXY_URL
        };
        console.log("Using modified config with HTTPS proxy" );
        setBotConfig(modifiedConfig);

      } catch (err: unknown) {
        console.error('Error loading bot config:', err);
        setError(err instanceof Error ? err.message : 'Unknown error fetching config');
        setError('Failed to load bot configuration from worker');
        setBotConfig(null);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []); // Removed isLocalhost from dependency array, runs only once on mount

  // Show loading state (or render nothing during loading)
  if (loading) {
    console.log("ChatBot loading..."); // Optional: Log loading state
    return null; // You can replace with a loading indicator if needed
  }

  // Show error state (or render nothing on error)
  // This check might need adjustment depending on whether you want to show the bot with fallback config even if there was an error
  if (error && !botConfig) { // Original check: only show error if botConfig is null
     console.error("ChatBot error state:", error);
     return <div>Error loading ChatBot configuration.</div>; // Provide user feedback on error
  }

  // If we have a config (either fetched or fallback), render the chat bot
  return botConfig ? (
    <BubbleChat
      chatflowid={botConfig.chatflowid}
      apiHost={botConfig.apiHost}
      theme={{    
        button: {
          right: 20,
          bottom: 20,
          size: 56,
          dragAndDrop: true,
          iconColor: 'white',
          customIconSrc: 'https://img.icons8.com/?size=100&id=BPFfi69JReUf&format=png&color=000000',
          autoWindowOpen: {
            autoOpen: false,
            openDelay: 3,
            autoOpenOnMobile: false,

          }
        },
      
        disclaimer: {
          title: 'Bienvenue',
          message: "Je suis l'assistant de Mopaossi. Comment puis-je vous aider aujourd'hui?",
          textColor: '#303235',
          buttonColor: '#3b81f6',
          buttonText: 'Commencer',
          buttonTextColor: 'white',
          blurredBackgroundColor: 'rgba(0, 0, 0, 0.4)',
          backgroundColor: 'white'
        },
        customCSS: `
          .bubble-chat-button {
            transition: all 0.3s ease;
          }
          .bubble-chat-button:hover {
            transform: scale(1.05);
          }
          .bubble-chat-tooltip {
            animation: fadeInUp 0.5s ease forwards;
          }
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `,
        chatWindow: {
          showTitle: true,
          showAgentMessages: true,
          title: 'Assistant Mopaossi',
          titleAvatarSrc: '/bucket/avatar.png',
          welcomeMessage: 'Bonjour ! Je suis l\'assistant de Mopaossi. Comment puis-je vous aider aujourd\'hui ?',
          errorMessage: 'Désolé, une erreur s\'est produite. Veuillez réessayer.',
          backgroundColor: '#ffffff',
          height: 600,
          width: 380,
          fontSize: 16,
          starterPrompts: [
            "Qui est Mopaossi ?",
            "Quelles sont ses compétences ?",
            "Comment le contacter ?"
          ],
          starterPromptFontSize: 15,
          clearChatOnReload: false,
          sourceDocsTitle: 'Sources:',
          renderHTML: true,
          botMessage: {
            backgroundColor: '#f7f8ff',
            textColor: '#303235',
            showAvatar: true,
            avatarSrc: '/bucket/avatar.png'
          },
          userMessage: {
            backgroundColor: '#3b81f6',
            textColor: '#ffffff',
            showAvatar: true,
            avatarSrc: '/bucket/user-icon.png'
          },
          textInput: {
            placeholder: 'Posez votre question...',
            backgroundColor: '#ffffff',
            textColor: '#303235',
            sendButtonColor: '#1b45c0',
            maxChars: 200,
            maxCharsWarningMessage: 'Votre message est trop long. Veuillez le raccourcir.',
            autoFocus: true,
            sendMessageSound: true
          },
          feedback: {
            color: '#1b45c0'
          },
          dateTimeToggle: {
            date: true,
            time: true
          },
          footer: {
            textColor: '#303235',
            text: 'Propulsé par',
            company: '𝓓𝓔𝓒𝓞𝓓𝓔',
            companyLink: 'https://cbenji.pages.dev'
          }
        }
      }}
    />
  ) : null; // Should ideally not be null if loading is false and there's a fallback
};

export default ChatBot;